import { AiModel } from "@/shared/model/enum/ai-model_type";
import { Select, SelectItem, SelectSection } from "@heroui/react";

type SelectAiModelProps = {
  active: boolean;
  selectedAiModel: AiModel | null;
  setSelectedAiModel: (aiModel: AiModel) => void;
  enabled: boolean;
};

export const SelectAiModel = ({
  active,
  selectedAiModel,
  setSelectedAiModel,
  enabled,
}: SelectAiModelProps) => {
  return (
    <Select
      label="AI model"
      aria-label="Select AI model"
      placeholder="Select AI model"
      defaultSelectedKeys={[AiModel.gemini2Flash.code]}
      disabledKeys={!active ? AiModel.paid.map((model) => model.code) : []}
      selectedKeys={selectedAiModel ? [selectedAiModel.code] : []}
      isDisabled={!enabled}
      onSelectionChange={(selectedKeys) => {
        const firstKey = selectedKeys.anchorKey;

        setSelectedAiModel(
          AiModel.all.find((model) => model.code === firstKey)!
        );
      }}
    >
      <SelectSection showDivider title="Free">
        {AiModel.free.map((model) => (
          <SelectItem key={model.code}>{model.name}</SelectItem>
        ))}
      </SelectSection>

      <SelectSection showDivider title="All-access plan">
        {AiModel.paid.map((model) => (
          <SelectItem key={model.code}>{model.name}</SelectItem>
        ))}
      </SelectSection>
    </Select>
  );
};
